import {initMenuDatanew} from "@/api";


export const initMenu = (router,store)=>{

    // if(store.state.routes.length>0){
    //     return;
    // }

    initMenuDatanew().then(data=>{
        if(data){
            //格式化Router
            let fmRoutes = formatRoutes(data.data);
            //添加到路由
            for(let i = 0;i<fmRoutes.length;i++){
                if(fmRoutes[i].children.length > 0){
                    for(let a = 0;a<fmRoutes[i].children.length;a++){
                        if(fmRoutes[i].children[a].children.length >0){
                            for (let b = 0;b<fmRoutes[i].children[a].children.length;b++){
                                router.addRoute('index',fmRoutes[i].children[a].children[b]);
                            }
                        } else {
                            router.addRoute('index',fmRoutes[i].children[a]);
                        }
                    }
                } else {
                    router.addRoute('index',fmRoutes[i]);
                }
            }
            //将数据存入vuex
            store.commit('initRoutes',fmRoutes);
        }
    })
}


export const formatRoutes = (routes) =>{
    let fmRoutes = [];
    routes.forEach(router=>{
        let {
            data:{
                path,
                icon,
                key,
            },
            label,
            children,
            value,
        } = router
        if(children && children instanceof Array){
            //递归
            children = formatRoutes(children);
        }
        let fmRouter = {
            path:path,
            name:label,
            icon:icon,
            key:key,
            value:value,
            children:children,
            component: () => import('../views'+path+'.vue')
            // component(resolve){
            //     require(['../views'+path+'.vue'],resolve);
            // }
        }
        fmRoutes.push(fmRouter)
    });
    return fmRoutes;
}

